angular.module("app").directive("colorUsePopularityBar", () => {
  let link = (scope) => {

  };

  return {
    restrict: "E",
    templateUrl: "app/directives/colorUsePopularityBar/colorUsePopularityBarView.html",
    link: link,
    scope: {
      data: "="
    }
  };
});
